export const careerThemeColor = '#43a3ff';

export const careerWorkHistory = [
  {
    company: 'Ascend FS',
    title: 'AI & Automation Engineer',
    type: 'Permanent Full-time',
    date: 'May 2025 - Present',
    location: 'Toronto, Ontario, Canada',
    achievements: [
      'Automation, Platforms: Led end-to-end planning, system design, and delivery of operational platforms spanning matching, messaging, payments, and dashboards, owning solutions from problem definition through production.',
      'Designed and deployed a worker-to-gig weighted scoring model (preferences, distance, ratings) to scale to 25,000+ workers and 200+ gigs/weekly while improving match quality and fairness.',
      'Built an internal operations CRM from scratch (React, FastAPI, Firestore on GCP) with automated workflows and manual override controls to streamline booking management, worker lifecycle, and client operations.',
      'Integrated end-to-end payment operations (inbound Stripe, outbound Dots payouts) using idempotency, retries, and status tracking to reliably process over $200k monthly with reduced operational risk.',
      'Rebuilt communications with Twilio to replace an outsourced tool, consolidating automated and manual worker/client messaging into the CRM to reduce costs, centralize operations and creating custom communication sequences.',
      'Deployed a VAPI AI voice agent to handle client and worker interactions across FAQs, account settings, and upcoming job management, offloading support volume and reducing operational burden on the support team.',
      'Unified event and operational data across all backend services into PostHog, building a single observability platform for system performance and business metrics and enabling non-technical stakeholders to surface insights through natural language queries.',
      'Built a Firestore to BigQuery analytics pipeline, transforming operational documents into structured analytics tables and enabling Looker Studio dashboards for job performance, revenue tracking, and operational metrics.',
    ],
  },
  {
    company: 'Ericsson',
    title: 'Automation Developer',
    type: 'Co-op',
    date: 'Sep 2022 - Aug 2023',
    location: 'Ottawa, Ontario, Canada',
    achievements: [
      'Automation, Workflows: Collaborated with stakeholders to gather requirements, clarify priorities, and deliver incremental automation improvements in an Agile environment, reducing operational friction.',
      'Built a Python pipeline to ingest email requests and create/update Jira tickets, improving request consistency and reducing manual documentation and assessment time.',
      "Maintained Microsoft-stack automation's (Azure/Power Platform) and resolved recurring integration failures in legacy workflows to improve up-time and reduce repeated incidents.",
      'Partnered with stakeholders in an Agile environment to scope and ship incremental automation improvements, reducing operational friction through iterative releases.',
    ],
  },
  {
    company: 'JSI Telecom',
    title: 'Software Developer',
    type: 'Co-op',
    date: 'Jan 2022 - Apr 2022',
    location: 'Ottawa, Ontario, Canada',
    achievements: [
      'Revitalized a load testing system by debugging existing code, providing a reliable solution that restored our means to perform testing. Through this restoration, we could more accurately predict the scalability of our systems, eliminating guesswork.',
      'Leveraged SourceTree, Git, Slack, and Jenkins to manage coding workloads, version control, and development workflows.',
    ],
  },
  {
    company: 'Metrolinx',
    title: 'Summer Student',
    type: 'Contract Full-time',
    date: 'May 2021 - Aug 2021',
    location: 'Toronto, Ontario, Canada',
    achievements: [
      'Presented unresolved door system issues to team members to determine an action plan to reduce future recurring problems.',
      'Incorporated formulas and graphs within working copies of excel spreadsheets to improve efficiency for documentation and readability of information.',
      'Trained new members in the team in preparation to take over my position to ensure a seamless transition of tasks.',
    ],
  },
];
